import apiCall from '../components/apiCall';
import actions from '../actions';
import {
  UPDATE_PROJECT,
} from './types';
import lang from '../lang';
import Defines from '../Defines';

const fetchProject = (projectId) => (dispatch, getState) => {
  const url = `/project/${projectId}/simulationgame`;
  return apiCall(url, null, 'GET')
    .then((project) => {
      dispatch(updateProject(project, true));
    });
};

const myProject = () => (dispatch) => {
  return apiCall('/project/me')
    .then((project) => {
      dispatch(fetchProject(project.id));
    });
};

const refreshProject = () => (dispatch, getState) => {
  const state = getState();
  dispatch(fetchProject(state.project.id));
};

const updateProject = (project, fetchPolicyChoices = false) => async (dispatch, getState) => {
  const { user } = getState();
  let schoolClassId = 0,
      groupId = 0,
      schoolClass = undefined,
      group = undefined,
      gameState = undefined;

  // Set schoolClassId
  if (user.role === 'classleader') {
    schoolClassId = user.userDetails.ownedClass.id;
  } else if (['groupleader', 'groupmember'].includes(user.role)) {
    schoolClassId = user.userDetails.group.SchoolClassId;
  }

  if (schoolClassId) {
    // Fetch schoolClass data
    schoolClass = await apiCall(`/schoolClass/${schoolClassId}/simulationgame`, null, 'GET');

    // Set groupId
    if (['groupleader', 'groupmember'].includes(user.role)) {
      groupId = user.userDetails.ownedGroup ? user.userDetails.ownedGroup.id : user.userDetails.group.id;
    } else {
      groupId = schoolClass.Groups[0].id;
    }
    group = await apiCall(`/group/${groupId}/simulationgame`, null, 'GET');

    // Find and set gameState
    if (group && Array.isArray(group.Rounds)) {
      gameState = {
        Rounds: group.Rounds || {},
        gameStateSum: group.gameStateSum || {},
      };
    }

    if (user.role === 'groupleader' || user.role === 'groupmember') {
      const currentRound = group.Rounds[group.Rounds.length - 1] || { id: 0 };
      dispatch(actions.policyChoice.updatePolicyOptions(currentRound.id));
    }
  }

  if (user.role === 'groupleader' || user.role === 'groupmember' || user.role === 'classleader') {
    lang.setLanguage(schoolClass.Language.code);
  } else {
    lang.setLanguage(project.defaultLanguage.code);
  }

  if (project.lite) {
    Defines.applyLiteOverrides();
  }

  dispatch({ type: UPDATE_PROJECT, payload: {
    project,
    schoolClass: {
      ...schoolClass,
      loaded: true,
    },
    group: {
      ...group,
      loaded: true,
    },
    gameState,
  }});
};

export default {
  fetchProject,
  myProject,
  updateProject,
  refreshProject,
};



// WEBPACK FOOTER //
// ./src/actions/project.js